import Image from "../global/Image";
import styles from "./index.module.scss";
import pdf from "../../assets/img/pdf.png";
import { useEffect, useMemo, useRef, useState } from "react";
import useWindowScroll from "../../lib/use/useWindowScroll";

const Galery = ({ project, setImage }) => {
  const [translation, setTranslation] = useState(0);
  const style = useMemo(
    () => ({
      transform: "translateY(" + translation + "px)",
    }),
    [translation]
  );
  const galeryRef = useRef();
  const scroll = useWindowScroll();
  let files = project.files;
  let videos = project.videos;

  useEffect(() => {
    let rectangle = galeryRef.current.getBoundingClientRect();

    setTranslation((t) => {
      let n = t + (rectangle.y - 30) * -1;
      if (n < 0) n = 0;
      return n + 20;
    });
  }, [scroll]);

  return (
    <aside className={styles.projectGalery}>
      <div className={styles.projectTrack} ref={galeryRef} style={style}>
        <h3 className={styles.subtitleBlack} data-annexes>Annexes</h3>
        <div className={styles.filesGrid}>
          {files.map((file, i) => {
            return (
              <div key={"file-" + i} className={styles.fileItem}>
                {file.ext == ".pdf" ? (
                  <a href={file.url} target="_blank">
                    <div className={styles.pdfFile}>
                      <div>
                        <Image src={pdf} alt="thumbnail-file-pdf" />
                      </div>
                      <span>Ouvir</span>
                    </div>
                  </a>
                ) : (
                  <div className={styles.imageGalery + " previewImage"}>
                    <Image
                      image={file}
                      alt={
                        Boolean(file?.alternativeText)
                          ? file.alternativeText
                          : "thumbnail-asset-project"
                      }
                      breakpoints={{ large: null, medium: null }}
                      onClick={(e) =>
                        setImage({
                          x: e.clientX,
                          y: e.clientY,
                          img: file.url,
                        })
                      }
                    />
                  </div>
                )}
              </div>
            );
          })}
          {videos.map((video, i) => {
            return (
              <div
                key={"video-" + i}
                className={styles.imageGalery + " previewImage " + styles.video}
              >
                <div style={{ height: "100%", width: "100%" }}>
                  <Image
                    image={video.thumbnail}
                    alt={video.thumbnail.alt("thumbnail-asset-project")}
                    breakpoints={{ large: null, medium: null }}
                    fit="contain"
                    onClick={(e) =>
                      setImage({
                        x: e.clientX,
                        y: e.clientY,
                        img: "",
                        video: video.link,
                        type: "video",
                      })
                    }
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </aside>
  );
};

export default Galery;
